<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" fill="white" fill-opacity="0.01"/>
    <path d="M14.965 10.226H14.255V13.774H14.964C15.939 13.774 16.468 13.159 16.468 11.971C16.468 10.853 15.911 10.226 14.965 10.226Z" fill="#42526E"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.359 9.004V15H9.859V12.582H7.504V15H6V9.004H7.504V11.356H9.859V9.004H11.359ZM15.235 15H12.752V9H15.235C16.996 9 18 10.068 18 11.942C18 13.911 17.013 15 15.235 15Z" fill="#42526E"/>
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
